// extracted by mini-css-extract-plugin
module.exports = {"section":"hero-module--section--35sOq","image":"hero-module--image--2rv0b"};